import React from "react";
import { benchmarks, Benchmark } from "../../data/findings";
const pos = (b: Benchmark, v: number) => (v - b.min) / (b.max - b.min) * 100;
const fmt = (b: Benchmark, v: number) => `${v}${b.suffix}`;
export function PercentileBenchmark() {
  return <div data-id="element-508" data-mp="303gdlugwh21o">
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 pb-5 text-[11px] text-charcoal/65" data-id="element-509" data-mp="3036vet23jz6j">
        <span className="flex items-center gap-2" data-id="element-510" data-mp="3rsifa8hhqsy2">
          <span aria-hidden className="block h-2.5 w-6 bg-navy/15" data-id="element-511" data-mp="3rr8f9dr2vaos" />
          Middle 50% of respondents
        </span>
        <span className="flex items-center gap-2" data-id="element-512" data-mp="3nrq439p26dz5">
          <span aria-hidden className="block h-3.5 w-px bg-navy" data-id="element-513" data-mp="3izoigx603awg" />
          Median
        </span>
        <span className="flex items-center gap-2" data-id="element-514" data-mp="3e1n3ooflxxqs">
          <span aria-hidden className="block h-2.5 w-2.5 rounded-full bg-oxblood" data-id="element-515" data-mp="3e0v8vftu441k" />
          Stage IV+ organizations
        </span>
      </div>

      <ul className="border-t border-stone" data-id="element-516" data-mp="ajv2qkjhu3gg">
        {benchmarks.map(b => <li key={b.metric} className="border-b border-stone py-5" data-id="element-517" data-mp="3ged9awqq7pbk">
            <div className="flex items-baseline justify-between gap-4" data-id="element-518" data-mp="3gf55o9s5dr2w">
              <p className="text-sm font-medium text-charcoal" data-id="element-519" data-mp="3lc52rv70rjhv">{b.metric}</p>
              {b.lowerIsBetter && <p className="shrink-0 text-[11px] text-charcoal/55" data-id="element-520" data-mp="37l07t6eljfdv">Lower is better</p>}
            </div>

            <div className="mt-4 grid grid-cols-12 items-center gap-x-4" data-id="element-521" data-mp="3bmc2hqcbuqsx">
              <div className="col-span-12 sm:col-span-8" data-id="element-522" data-mp="2xnm66cxc0v5m">
                <div className="relative h-6" aria-hidden data-id="element-523" data-mp="2xq8cyacef6ms">
                  <span className="absolute inset-x-0 top-1/2 h-px bg-charcoal/20" data-id="element-524" data-mp="32nrr7a93jjeq" />
                  <span className="absolute top-1/2 h-2.5 -translate-y-1/2 bg-navy/15" style={{
                left: `${pos(b, b.p25)}%`,
                width: `${pos(b, b.p75) - pos(b, b.p25)}%`
              }} data-id="element-525" data-mp="2onz0hexkl36r" />
                  <span className="absolute inset-y-0 w-px bg-navy" style={{
                left: `${pos(b, b.median)}%`
              }} data-id="element-526" data-mp="mwcbtk15hkdg" />
                  <span className="absolute top-1/2 h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-oxblood" style={{
                left: `${pos(b, b.leaders)}%`
              }} data-id="element-527" data-mp="qvbmll9kcbct" />
                </div>
                <div className="mt-1 flex justify-between text-[10px] tabular-nums text-charcoal/50" aria-hidden data-id="element-528" data-mp="1qt68eyhtb36k">
                  <span data-id="element-529" data-mp="1lvmw444od0h9">{fmt(b, b.min)}</span>
                  <span data-id="element-530" data-mp="1lwxybzih2069">{fmt(b, b.max)}</span>
                </div>
              </div>
              <dl className="col-span-12 mt-3 grid grid-cols-2 gap-4 sm:col-span-4 sm:mt-0 sm:text-right" data-id="element-531" data-mp="2ik2jbtkbaxr7">
                <div data-id="element-532" data-mp="2eld929uklwbs">
                  <dt className="text-[10px] uppercase tracking-[0.12em] text-charcoal/55" data-id="element-533" data-mp="29saf40lvskv2">Median</dt>
                  <dd className="mt-1 font-display text-xl tabular-nums text-navy" data-id="element-534" data-mp="24tpcjuj5pp3g">{fmt(b, b.median)}</dd>
                </div>
                <div data-id="element-535" data-mp="329wjaux6kj6i">
                  <dt className="text-[10px] uppercase tracking-[0.12em] text-charcoal/55" data-id="element-536" data-mp="32aeahd4zk77k">Stage IV+</dt>
                  <dd className="mt-1 font-display text-xl tabular-nums text-oxblood" data-id="element-537" data-mp="2xgtn0f10qvmm">{fmt(b, b.leaders)}</dd>
                </div>
              </dl>
            </div>
          </li>)}
      </ul>
    </div>;
}